<ng-container *ngIf="scope$ | async as scope">
  <amp-engine-tag-value-detail
    [style.height]="'100%'"
    [assignmentScope]="scope"
    [showSiteLabel]="false"
    [editable]="editable$ | async"
    (changeDetails)="changeDetails = $event"
  ></amp-engine-tag-value-detail>
</ng-container>
